import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ParentRelationship,
  AppState,
  AppTypes,
  AppFields,
  take,
} from "../../../store";
import { MyProfileDashboardService } from "../../../services";
import { NotificationsService } from "angular2-notifications";
import { Store } from "@ngrx/store";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { EvaluationsService } from "../../../services/evaluations.service";
import * as lodash from "lodash";
import { AlertService } from "../../../services/alert.service";

@Component({
  selector: "app-evaluation-complete",
  templateUrl: "./evaluation-complete.component.html",
  styleUrls: ["./evaluation-complete.component.css"],
})
export class PlayerEvaluationCompleteComponent implements OnInit {
  evaluationName: any;
  evaluatorName: any;
  averageScore: any;
  playerFullName: any;
  playerAvatar: any;
  categories: any;
  responses: any;
  filteredResponses: any;
  responsesCopy: any;

  playerID: any;
  userEvaluationID: any;
  statusID: any;
  userID: any;
  evalStatus: number;

  selectedCategory: string = "ALL";
  showCategories: boolean = false;
  showScoreColumn: boolean = true;
  evaluationPresetCategoryID: number;

  evaluationResponsesForm: FormGroup;

  public urlLinks = [
    {
      title: "All Evaluations",
      url: "/staff/all/evaluations",
    },
    { title: "Details", url: null },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _loadingService: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private _service: EvaluationsService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.playerID = this.route.snapshot.params.playerID;
    this.userEvaluationID = this.route.snapshot.params.userEvaluationID;
    this.statusID = this.route.snapshot.params.status;
    this.userID = +localStorage.getItem("userId");
    this.loadEvaluationTemplateResults(this.playerID, this.userEvaluationID);
  }

  loadEvaluationTemplateResults(playerID, userEvaluationID) {
    this._loadingService.show();
    this._service
      .loadEvaluationTemplateResults(playerID, userEvaluationID)
      .subscribe(
        (response: any) => {
          this.evaluationName = response.data.evaluationName;
          this.playerFullName = response.data.playerFullName;
          this.playerAvatar = response.data.playerAvatar;
          this.averageScore = response.data.averageScore;
          this.categories = response.data.categories;
          this.evalStatus = response.data.evaluationStatus;

          this.responses = response.data.questionResponses;
          this.responsesCopy = this.responses;

          //Filter By Responses
          console.log("response.data ==>> ", response.data);

          this.filterByCategory(
            this.categories[0].categoryID,
            this.categories[0].categoryName,
            this.categories[0].evaluationPresetCategoryID
          );

          this._loadingService.hide();
        },
        (error) => {
          this._loadingService.hide();
          this._alertService.error("Evaluations could not be loaded");
        }
      );
  }

  showDashboard() {
    this.router.navigate(["staff/all/evaluations"]);
  }

  createform(responses: any) {
    let arr = [];
    for (let i = 0; i < responses.length; i++) {
      arr.push(this.addResponseField(this.responses[i]));
    }

    this.evaluationResponsesForm = this._fb.group({
      evaluationResponses: this._fb.array(arr),
    });
  }

  addResponseField(response): FormGroup {
    return this._fb.group({
      evaluationQuestionID: [response.questionID],
      evaluationResponseID: [response.evaluationResponseID],
      questionName: [response.questionName],
      score: [
        response.score,
        [Validators.required, Validators.min(0), Validators.max(5)],
      ],
      comment: [response.comment],
    });
  }

  onSave(event: Event = null) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // console.log(this.evaluationResponsesForm.value);
    // console.log("FORM VALID     ====>    ", this.evaluationResponsesForm.valid);
    // console.log(
    //   "FORM VALID     ====>    ",
    //   this.evaluationResponsesForm.errors
    // );

    if (this.evaluationResponsesForm.valid) {
      this._loadingService.show();
      this._service
        .updateEvaluationTemplateResult(
          this.userEvaluationID,
          this.userID,
          this.evaluationPresetCategoryID || 0,
          this.evaluationResponsesForm.value.evaluationResponses
        )
        .subscribe(
          (result) => {
            // this._loadingService.hide();
            this._alertService.success("Evaluation results updated");
            this.loadEvaluationTemplateResults(
              this.playerID,
              this.userEvaluationID
            );
          },
          (error) => {
            this._loadingService.hide();
            this._alertService.error("Evaluation results could not be updated");
          }
        );
    } else {
      this._alertService.warn("Please, enter scores between 0 and 5");
    }
  }

  onCancel(event: Event = null) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.createform(this.responses);
  }

  onScoreKeyUp(event: any) {
    const newValue = event.target.value;

    if (event.target.value) {
      if (this.isBetween0and5(newValue)) {
        console.log("===>   VALID   <===");
      } else {
        this._alertService.warn("Please, enter a score between 0 and 5");
        console.log("===>   IN-VALID   <===");
      }
    } else {
      this._alertService.warn("Please, enter a score between 0 and 5");
    }
  }

  isBetween0and5(n) {
    return (n - 0) * (n - 5) <= 0;
  }

  filterByCategory(
    categoryID,
    categoryName,
    evaluationPresetCategoryID = null
  ) {
    this.responses = this.responsesCopy;
    if (categoryID > 0) {
      this.showCategories = true;
      this.showScoreColumn = true;
      this.evaluationPresetCategoryID = evaluationPresetCategoryID;

      this.selectedCategory = categoryName;
      this.responses = this.responses.filter((n) => n.categoryID == categoryID);

      if (evaluationPresetCategoryID == 3) {
        this.showScoreColumn = false;
      }

      this.createform(this.responses);
    } else {
      this.showCategories = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/player/evaluation-complete/evaluation-complete.component.ts